export default {
  id: null,
  nome: null,
  anexo: false
}



// WEBPACK FOOTER //
// ./src/shared/models/configurations/expensetypemodel.js